<template>
  <v-list-item
    class="vertical-nav-menu-link"
    v-bind="$attrs"
    active-class="bg-gradient-primary white--text"
  >
    <v-list-item-icon>
      <v-icon
        :class="{'alternate-icon-small': !icon}"
        class="mx-auto"
      >
        {{ icon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title>
      <span :class="'float-left' + (locale ? ' mt-3' : '')">
        {{ title }}
      </span>
      <span class="float-right">
        <country-flag
          v-if="locale"
          class="nmb-5"
          :country="locale"
          size="normal"
          shadow
        />
      </span>
      <div class="clear"></div>
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    locale: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      default: undefined
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '~vuetify/src/styles/styles.sass';

.alternate-icon-small {
  font-size: 14px;
  height: 14px;
  width: 14px;
}

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }
}
</style>
